import React,  { useState }   from "react"
import CTA from "../../components/CTA"
import { Container } from "@material-ui/core"
import Layout from "../../components/Layout"


import Hero from "./../../components/Hero"

import ux from "./../../assets/services/app-dev/ux.png"
import agile from "./../../assets/services/app-dev/agile.png"
import lean from "./../../assets/services/app-dev/lean.png"



function Page() {

  const [status, setStatus] = useState(1);
  return (
    <Layout
      cssClass="app-dev services--page"
      title="INVIZ AI Solutions | Application Development"
      description="We are a global software and intelligence consultancy company focused on building software, cloud and data solutions with intelligence."
    >

      <Hero>
        <p className="xlarge">Custom built applications to fit your every business need</p>
      </Hero>    

      
 

      <section>
        <Container>
          <div className="text-center">
        <p>We build high performing, feature packed web and mobile apps tailored for your business needs. With focus on increasing customer experience, our application development services help build applications that will engage and delight your users.</p>
        </div>     
           <br />           
          <ul className="flex">
            <li className="xs-12 md-4">
              <div className="design">
                <h4><b>Design & Architecture</b></h4>
                <div>
                  <p>Our research-based design & architecture approach ensures par excellence user-experience, which is aligned with your business needs</p>
                </div>
              </div>
            </li>
            <li className="xs-12 md-4">
              <div className="develop">
                <h4><b>Development</b></h4>
                <div>
                  <p>Inviz's development best practices ensure high quality code, effective product funcitonalities and performance.</p>
                </div>
              </div>
            </li>
            <li className="xs-12 md-4">
              <div className="support">
                <h4><b>Support</b></h4>
                <div>
                  <p>Our Support servies ensure stability of the applications post development, across various staging in the product lifecycle</p>
                </div>
              </div>
            </li>            
          </ul>
        </Container>
      </section>
      <section>
          <div className="tabs">            
              <b className={status===1? 'active' : ''} onClick={() => setStatus(1)}>UI &amp; UX</b>         
              <b className={status===2? 'active' : ''} onClick={() => setStatus(2)}>Agile</b>            
              <b className={status===3? 'active' : ''} onClick={() => setStatus(3)}>Lean Principles</b>             
          </div>
          <Container>
          <div className={`tabs__content text-center tabs__content__${status}`}>
            <div className="flex">
              <div className="tabs__content__item">
                <figure>
                  <img src={ux} alt=""/>
                </figure>
                <div className="text">
                <h4><b className="green"> UI &amp; UX</b></h4>
                <div>
                  <p>We play the dual role of artists and analysts when it comes to UI designing. Taking inputs from quantitative metrics, such as the end user usage, and qualitative metrics, such as  surverys, inputs and feedback, we iteraatively build applicationsthat are visually appealing and functionally effective </p>
                </div>
                </div>
                
              </div>
              <div className="tabs__content__item">
              <figure>
                  <img src={agile} alt=""/>
                </figure>
                <div className="text">
              <h4><b className="green"> Agile</b></h4>
              <div>
                  <p>We are hard core proponents of agile software development methodologies. We have embraced agile in the purest form and have made it a part of our DNA. We help companies adopt the agile way of thinking and build high performance teams, which can transforms the way product and tech teams collaborate. </p>
                </div>
                </div>
             
              </div>
              <div className="tabs__content__item">
              <figure>
                  <img src={lean} alt=""/>
                </figure>
                <div className="text">
              <h4><b className="green"> Lean Principles</b></h4>
              <div>
                  <p>Lean thinking enables rapid product-market fit identification, by continuous experimentation and empirical decisions. Using these principles, we minimize risk, both interms of time and money, and maximize results, including customer engagement and other business outcomes</p>
                </div>
                </div>
             
              </div>
            </div>
          </div>
          </Container>

      </section>

      <CTA>
      If you feel, we could help <b className="green">solve your business problem</b>,        
      </CTA>
    </Layout>
  )
}

export default Page
